export default __webpack_public_path__ + "static/media/silhouette_2.115c7ae9.png";